require('floatthead');


$(function () {
    yieldMonitorTable = {
        endpoint: '/Main/YieldMonitorBlock/GetMultiColumnData',
        tableData: {},
        retrieved: false,
        wrapperDiv: $('#veYieldMonitorETFTable'),
        deskTopTableDiv: "YieldMonitorDesktopTable",
        tableHeaderArray: [],
        tableCellClasses: [],
        tableTitleArray:[],
        isExcelDownloading: false,
        toggleEventListenersAdded: false,
        groupTitles: [],
        blockId: $('#veYieldMonitorETFTable').attr("data-blockid"),
        init: async () => {
            commonFundUtils.spinner.show("YieldMonitorDesktopTable");
            yieldMonitorTable.tableData = await commonFundUtils.getData(yieldMonitorTable.blockId, yieldMonitorTable.endpoint)
            yieldMonitorTable.drawTable()
            yieldMonitorTable.drawMobileTable()
            commonFundUtils.spinner.hide("YieldMonitorDesktopTable");
        },
        drawTable: () => {
            commonFundUtils.drawDesktopTable(
                "veYieldMonitorETFTable",
                yieldMonitorTable.deskTopTableDiv,
                yieldMonitorTable.tableData,
                yieldMonitorTable.drawHeader,
                yieldMonitorTable.tableData.Columns,
            )
            yieldMonitorTable.drawBlock(yieldMonitorTable.tableData.Groups, yieldMonitorTable.isExcelDownloading)
            yieldMonitorTable.enableHeaderClicks()
            commonFundUtils.initiatePopover()
        },
        //used to draw the table header
        drawHeader: (dataSet) => {
            var tableheader;
            yieldMonitorTable.tableHeaderArray = [];
            yieldMonitorTable.tableCellClasses = [];
            yieldMonitorTable.tableTitleArray = [];
            tableheader = '<thead><tr>';
            $.each(dataSet, function () {
                tableheader += '<th class="table-header-item ' + this.CellClass + ' ' + commonFundUtils.getUnderlinedClass("veYieldMonitorETFTable", this.ColumnName) + '" id="' + this.ColumnName + '"><span class="table-thead d-inline-flex">' + columnHeaderNameKVP[this.Name] + commonFundUtils.sortIconMarkup + '</span></th>';
                yieldMonitorTable.tableHeaderArray.push(this.ColumnName);
                yieldMonitorTable.tableCellClasses.push(this.CellClass);
                yieldMonitorTable.tableTitleArray.push(columnHeaderNameKVP[this.Name])
            })
            tableheader += '</tr></thead>';
            return tableheader;
        },
        //used to draw the table body
        drawBlock: (dataSet, isExcel) => {
            var tableBlock = '';
            yieldMonitorTable.groupTitles = Object.keys(dataSet);
            var count = 0;
            tableBlock += '<tbody>';
            //loop through each group
            $.each(dataSet, function (index) {
                tableBlock += '<tr class="table-title grouping"><td colspan="' + yieldMonitorTable.tableHeaderArray.length+'" class="text-left bold pt-3"><h5>' + yieldMonitorTable.groupTitles[count] + '</h5></td></tr>';
                count++;
                tableBlock += commonFundUtils.drawItemsInGroup(this, yieldMonitorTable.tableCellClasses, yieldMonitorTable.tableHeaderArray,false ,isExcel);
            })
            tableBlock += '</tbody>'
            if (isExcel) {
                yieldMonitorTable.isExcelDownloading = false
                return tableBlock
            } else {
                $('#veYieldMonitorETFTable table').append(tableBlock);
            }
        },
        //activate button clicks
        enableHeaderClicks: () => {
            $('#veYieldMonitorETFTable .table-header-item').on("click", function () {
                commonFundUtils.changeDivAttributes(this, yieldMonitorTable.wrapperDiv)
                yieldMonitorTable.tableData.Groups = commonFundUtils.sortDataArray(yieldMonitorTable.tableData, yieldMonitorTable.wrapperDiv)
                yieldMonitorTable.drawTable()
            })
            //to run the excel button click event listner only once
            if (yieldMonitorTable.toggleEventListenersAdded) return
            //activating the "download excel" button click only once
            commonFundUtils.generateExcelTable("veYieldMonitorETFTable",yieldMonitorTable.drawExcelTable)
            yieldMonitorTable.toggleEventListenersAdded = true
        },
        drawMobileTable: () => {
            var count = 0;
            var mobileTable = '';
            mobileTable += '<div class="d-lg-none">'
                + '<div class="fund-listing-table table-mobile" id="overview">'
            $.each(yieldMonitorTable.tableData.Groups, function () {
                mobileTable += '<h3 class="my-3">' + yieldMonitorTable.groupTitles[count] + '</h3>';
                mobileTable += yieldMonitorTable.drawMobileCardArray(this, 2, yieldMonitorTable.tableHeaderArray )
                count++;
            })
            if ($('#veYieldMonitorETFTable .table-mobile .table-footer').length == 0 && yieldMonitorTable.tableData.AsOfDateText) {
                mobileTable += '<div class="table-footer mt-3"> <strong>' + yieldMonitorTable.tableData.AsOfDateText + '</strong></div>';
            }
            if ($('#veYieldMonitorETFTable .table-mobile .table-footer').length == 0 && yieldMonitorTable.tableData.FooterText) {
                mobileTable += '<div class="table-footer mt-3">' + yieldMonitorTable.tableData.FooterText + '</div>';
            }
            mobileTable += '</div></div>'
            $(yieldMonitorTable.wrapperDiv).append(mobileTable);
        },
        drawMobileCardArray: (dataSet, headerColumns, headerArray) => {
            var mobileCard = ''
            $.each(dataSet, function () {
                mobileCard += '<div class="fund-explorer-table__card">';
                mobileCard += commonFundUtils.drawMobileHeader(this, headerColumns, headerArray)
                mobileCard += '<div class="row">'
                mobileCard += commonFundUtils.drawMobileItems(this, headerColumns, headerArray.length, headerArray, yieldMonitorTable.tableTitleArray)
                mobileCard += '</div>'
                mobileCard += '</div>'
            })
            return mobileCard;
        },
        drawExcelTable: (wrapperDiv) => {
            var excelTable = '';
            yieldMonitorTable.isExcelDownloading = true
            $('#excelDrawArea table').remove();
            excelTable += '<table class="d-none excel-table" border="1">';
            excelTable += yieldMonitorTable.drawHeader(yieldMonitorTable.tableData.Columns)
            excelTable += yieldMonitorTable.drawBlock(yieldMonitorTable.tableData.Groups, yieldMonitorTable.isExcelDownloading)
            excelTable += '</table>';
            $('#excelDrawArea').append(excelTable);
            commonFundUtils.downloadExcelReport(wrapperDiv)
        }
    }

    //function is only initiated if the block ID is a number
    if (!isNaN(yieldMonitorTable.blockId)) {
        yieldMonitorTable.init()
    }
    
})